<template>
  <v-card outlined style="margin-bottom: 24px">
    <UpdateLeadSaleForm
      ref="update-form"
      :profile="profile"
      :inChargeList="inCharge"
      @refresh="() => $emit('refresh')"
    />
    <div class="d-flex justify-space-between align-items-center py-6 pl-6">
      <h5 class="text-uppercase align-self-center">Phân loại và phân công chăm sóc</h5>
      <v-btn
        text
        color="blue darken-4"
        class="pr-6 document-btn no-hover"
        plain
        @click="() => $refs['update-form'].open()"
        style="height: 18px"
        v-if="authorized"
      >
        <v-icon left>mdi-playlist-edit</v-icon>
        Cập nhật
      </v-btn>
    </div>
    <v-row class="px-6" no-gutters>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Phân khúc</p>
        <p class="mt-0 mb-6">{{ profile.segment ? formatLead(profile.segment) : 'Chưa có thông tin' }}</p>
      </v-col>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Sản phẩm quan tâm</p>
        <p class="mt-0 mb-6">
          <template v-if="profile.products && hasNonEmptyProducts(profile.products)">
            <template v-for="(product, index) in profile.products">
              <a
                v-if="product"
                :key="index"
                :href="`/grades/${product.id}`"
                style="text-decoration: none"
                target="_blank"
                >{{ product.title }}</a
              >
              <span v-if="index < profile.products.length - 1" :key="'comma-' + index">, </span>
            </template>
          </template>
          <span v-else>Chưa có</span>
        </p>
      </v-col>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Mức độ quan tâm</p>
        <p class="mt-0 mb-6">{{ formatLead($_get(profile, 'interest', 'Chưa có thông tin')) }}</p>
      </v-col>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Ghi chú</p>
        <v-tooltip bottom max-width="180">
          <template v-slot:activator="{ on }">
            <p class="note-text mt-0" v-on="on">{{ profile.note }}</p>
          </template>
          <span>{{ $_get(profile, 'note', 'Không có') }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row class="px-6" no-gutters>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Người tạo</p>
        <p class="mt-0 mb-6">{{ formatLead(profile.createdByName) }}</p>
      </v-col>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Ngày tạo</p>
        <p class="mt-0 mb-6">{{ profile.createdAt | ddmmyyyy }}</p>
      </v-col>

      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Nguồn marketing</p>
        <p class="mt-0 mb-6">{{ formatLead($_get(profile, 'importOrigin', 'Chưa có')) }}</p>
      </v-col>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Người chịu trách nhiệm</p>
        <p class="mt-0 mb-6">
          <template v-if="profile.inCharge && profile.inCharge.length > 0">
            <template v-for="(inCharge, index) in profile.inCharge">
              <template v-if="user.role.type === 'manager'">
                <a :key="index" :href="`/admin/sale/${inCharge.id}`" style="text-decoration: none" target="_blank">
                  {{ inCharge.name ? inCharge.name : inCharge.username }}
                </a>
              </template>
              <template v-else>
                <span :key="index">{{ inCharge.name ? inCharge.name : inCharge.username }}</span>
              </template>
              <span v-if="index < profile.inCharge.length - 1" :key="'comma-' + index">, </span>
            </template>
          </template>
          <span v-else>Chưa có</span>
        </p>
      </v-col>
    </v-row>
    <v-row class="px-6" no-gutters>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Thời gian lịch hẹn</p>
        <p class="mt-0 mb-6">{{ latestAppointmentTime }}</p>
      </v-col>
      <v-col cols="3">
        <p class="grey--text mb-0 mt-0">Người phụ trách lịch hẹn</p>
        <p class="mt-0 mb-6">{{ latestAppointmentInCharge }}</p>
      </v-col>
      <v-col cols="6">
        <p class="grey--text mb-0 mt-0">Ghi chú lịch hẹn</p>
        <v-tooltip bottom max-width="180">
          <template v-slot:activator="{ on }">
            <p class="note-text mt-0 mb-6" v-on="on">{{ latestAppointmentNote }}</p>
          </template>
          <span>{{ latestAppointmentNote }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row class="px-6" no-gutters>
      <v-col cols="6">
        <p class="grey--text mb-0 mt-0">Ngày/giờ test</p>
        <p class="mt-0 mb-6">{{ profile.testDate | ddmmyyyyhhmm }}</p>
      </v-col>
      <v-col cols="6">
        <p class="grey--text mb-0 mt-0">Nội dung tư vấn</p>
        <p class="mt-0 mb-6" v-html="profile.consultNote" />
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
import formatLead from '@/helpers/translateLead.js'
import UpdateLeadSaleForm from '@/components/basic/form/UpdateLeadSaleForm.vue'
import moment from 'moment'
export default {
  props: {
    inCharge: Array,
    authorized: Boolean,
    latestAppointment: Object,
    loadingAppointments: Boolean,
  },
  components: { UpdateLeadSaleForm },
  data() {
    return {
      updateLeadDialog: false,
    }
  },
  computed: {
    ...mapGetters({ user: 'auth/user', profile: 'lead/item' }),
    latestAppointmentTime() {
      if (this.loadingAppointments) return 'Đang tải...'
      if (!this.latestAppointment || !this.latestAppointment.date) return ''
      return moment(this.latestAppointment.date).format('DD/MM/YYYY HH:mm')
    },
    latestAppointmentInCharge() {
      if (this.loadingAppointments) return 'Đang tải...'
      if (!this.latestAppointment) return ''
      return this.formatAppointmentInCharge(this.latestAppointment.inCharge)
    },
    latestAppointmentNote() {
      if (this.loadingAppointments) return 'Đang tải...'
      if (!this.latestAppointment) return ''
      return this.latestAppointment.note
    },
  },
  methods: {
    formatLead,
    hasNonEmptyProducts(products) {
      return products.some(product => Object.keys(product).length > 0)
    },
    formatAppointmentInCharge(inCharge) {
      if (!inCharge) return ''
      if (typeof inCharge === 'string') {
        const user = Array.isArray(this.inCharge) ? this.inCharge.find(item => item.id === inCharge) : null
        return user ? user.name || user.username : inCharge
      }
      return inCharge.name || inCharge.username || ''
    },
  },
}
</script>

<style>
.note-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
</style>
